import common from './common.json';
import auth from './auth.json';
import chat from './chat.json';
import characters from './characters.json';
import admin from './admin.json';
import billing from './billing.json';
import swipe from './swipe.json';
import profile from './profile.json';
import emailVerification from './emailVerification.json';
import userAttributes from './userAttributes.json';
import notifications from './notifications.json';
import creatorSpace from './creatorSpace.json';
import landing from './landing.json';
import dashboard from './dashboard.json';
import affiliate from './affiliate.json';
import unsubscribed from './unsubscribed.json';
import compliance from './compliance.json';
import games from './games.json';
import promotions from './promotions.json';

export default {
  common,
  auth,
  chat,
  characters,
  admin,
  billing,
  swipe,
  profile,
  emailVerification,
  userAttributes,
  notifications,
  creatorSpace,
  landing,
  dashboard,
  affiliate,
  unsubscribed,
  compliance,
  games,
  promotions,
};
